(function () {
  angular.module('app.behavior-analytics.quickview', []);

})();